import Onboard from 'bnc-onboard'

export default {
  namespaced: true,
  state: {
    balance: 0,
    userAddress: '',
    onboard: null,
  },
  getters: {
    shortAddress: state => {
      if (state.userAddress) {
        return `${state.userAddress.slice(0, 4)}...${state.userAddress.slice(-4)}`
      }
      return ''
    },
  },
  mutations: {

  },
  actions: {
    init({ state }) {
      state.onboard = Onboard({
        dappId: 'f45d6077-d15d-40eb-80e4-a61cc1ea87ce', // [String] The API key created by step one above
        networkId: 1, // [Integer] The Ethereum network ID your Dapp uses.
        subscriptions: {
          wallet: wallet => {
            localStorage.setItem('cachedWallet', wallet.name)
          },
          address: value => {
            state.userAddress = value
          },
        },
        walletSelect: {
          wallets: [
            { walletName: 'metamask', preferred: true },
            {
              walletName: 'walletConnect',
              infuraKey: '544713ddf80246a3b728102312f1db1b',
              preferred: true,
            },
            {
              walletName: 'fortmatic',
              apiKey: 'pk_live_14DB923EEA7D6DFD',
              preferred: true,
            },
            {
              walletName: 'portis',
              apiKey: '5dd27f80-e2ed-41b6-b42b-8b2f7f6e78f6',
              preferred: true,
              label: 'Login with Email',
            },

            { walletName: 'atoken' },
            { walletName: 'frame' },
            { walletName: 'ownbit' },
            { walletName: 'alphawallet' },
            { walletName: 'gnosis' },
            { walletName: 'xdefi' },
            { walletName: 'bitpie' },
            { walletName: 'binance' },
            { walletName: 'liquality' },
            { walletName: 'tally' },
            { walletName: 'blankwallet' },
            { walletName: 'mathwallet' },
            { walletName: '1inch' },
            { walletName: 'ronin' },
            { walletName: 'hyperpay' },
          ],
        },
      })
      const cachedWallet = localStorage.getItem('cachedWallet')
      if (cachedWallet) {
        state.onboard.walletSelect(cachedWallet)
      }
    },
    async connect({ state }) {
      await state.onboard.walletSelect()
      await state.onboard.walletCheck()
    },
    disconnect({ state }) {
      state.onboard.walletReset()
      localStorage.setItem('cachedWallet', null)
    },
  },
}
